import { fetchWrapper } from '../Helpers/fetchWrapper';
import { apiService } from './apiService';

const login = (username, password) => {
    const data = {
        username: username,
        password: password
    };
    return fetchWrapper.post(`${apiService.getApiUrl()}/login`, data);
};

const getProfile = () => {
    return fetchWrapper.get(`${apiService.getApiUrl()}/profile`);
};

const updateSettings = (data) => {
    return fetchWrapper.put(`${apiService.getApiUrl()}/profile/settings`, data);
};

const extendSession = () => {
    return fetchWrapper.get(`${apiService.getApiUrl()}/login/extend`);
};

const updateProfile = (data) => {
    return fetchWrapper.put(`${apiService.getApiUrl()}/profile`, data);
};

const getAllUsers = (orgId, userName) => {
    return fetchWrapper.get(`${apiService.getApiUrl()}/user/${orgId}/all/${userName}`);
};

const createUser = (orgId, user) => {
    return fetchWrapper.post(`${apiService.getApiUrl()}/user/${orgId}`, user);
};

const deleteUser = (orgId, userName) => {
    return fetchWrapper.deleteRequest(`${apiService.getApiUrl()}/user/${orgId}/delete/${userName}`);
};

const forgotPassword = (userName) => {
    return fetchWrapper.post(`${apiService.getApiUrl()}/login/forgotpassword`, {"userName": userName});
};

const resetPassword = (request) => {
    return fetchWrapper.post(`${apiService.getApiUrl()}/login/resetpassword`, request);
};

const getContacts = () => {
    return fetchWrapper.get(`${apiService.getApiUrl()}/contactus`);
};

export const userService = {
    login,
    getProfile,
    updateProfile,
    updateSettings,
    extendSession,
    getAllUsers,
    createUser,
    deleteUser,
    forgotPassword,
    resetPassword,
    getContacts
};

